<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>
        <b-button
          v-if="dataForm.some((el) => el.checked)"
          variant="danger"
          @click="bulkDeleteForm"
        >
          Bulk Delete
        </b-button>
      </div>
      <b-button v-if="!selectedData" variant="primary" @click="addForm">
        <i class="fa fa-plus"></i>
        Add Form
      </b-button>
    </div>
    <form @submit.prevent="handleSubmit">
      <table class="w-100 table-striped">
        <thead>
          <th v-if="!selectedData">
            <input
              :checked="dataForm.every((el) => el.checked) && dataForm?.length"
              type="checkbox"
              class="cursor-pointer"
              @change="handleCheckAll"
            />
          </th>
          <th>FLEET NAME</th>
          <th>DATE INPUT</th>
          <th>ENGINE NAME</th>
          <th>HOURS</th>
          <!-- <th>MINUTES</th> -->
        </thead>
        <tbody v-if="dataForm.length">
          <template v-for="(item, i) in dataForm">
            <tr v-for="(subItem, j) in item?.runningHours" :key="`${i}-${j}`">
              <td
                class="bg-white"
                v-if="j === 0 && !selectedData"
                :rowspan="item.runningHours?.length"
                style="border-bottom: 1px solid #dee2e6"
              >
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    class="mr-3 mb-0 cursor-pointer"
                    v-model="item.checked"
                  />
                  <i
                    class="fa fa-trash text-danger cursor-pointer"
                    @click="() => deleteForm(i)"
                  ></i>
                </div>
              </td>
              <td
                class="bg-white"
                v-if="j === 0"
                :rowspan="item.runningHours?.length"
                style="width: 280px; border-bottom: 1px solid #dee2e6"
              >
                <v-select
                  :options="fleetOptions"
                  v-model="item.vehicle_id"
                  @input="(val) => handleSelect(val, i)"
                  label="name"
                  :reduce="(option) => option?.id"
                ></v-select>
              </td>
              <td
                class="bg-white"
                v-if="j === 0"
                :rowspan="item.runningHours?.length"
                style="width: 280px; border-bottom: 1px solid #dee2e6"
              >
                <date-picker
                  value-type="DD-MM-YYYY"
                  type="date"
                  placeholder="Select date"
                  class="text-black"
                  format="DD-MM-YYYY"
                  v-model="item.date"
                  :disabled="selectedData"
                  :input-attr="{ required: true }"
                ></date-picker>
              </td>
              <td style="width: 400px">{{ subItem?.engineName }}</td>
              <td>
                <div class="d-flex align-items-center" style="max-width: 240px">
                  <div class="d-flex align-items-center" style="width: 110px">
                    <b-form-input
                      v-if="item.vehicle_id"
                      class="bg-white rounded-sm text-right"
                      v-model="subItem.hours"
                      style="width: 100px"
                      type="number"
                      placeholder="0"
                      :min="0"
                      :max="24"
                      @blur="handleBlurInput($event, subItem, 'hours')"
                    ></b-form-input>
                  </div>
                </div>
              </td>
              <!-- <td>
                <div class="d-flex align-items-center" style="width: 110px">
                  <b-form-input
                    v-if="item.vehicle_id"
                    placeholder="0"
                    type="number"
                    class="bg-white rounded-sm text-right"
                    v-model="subItem.minutes"
                    style="width: 100px"
                    :min="0"
                    :max="59"
                    @blur="handleBlurInput($event, subItem, 'minutes')"
                  ></b-form-input>
                </div>
              </td> -->
            </tr>
          </template>
        </tbody>

        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">No Data Form</td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex mt-4">
        <b-button
          variant="outline-primary"
          class="w-50 mr-3"
          @click="$emit('close')"
          type="button"
        >
          Cancel
        </b-button>
        <b-button
          v-if="!loading"
          :disabled="!dataForm?.length"
          variant="primary"
          type="submit"
          class="w-50"
        >
          Submit
        </b-button>
        <b-button variant="primary" v-else class="w-50" disabled>
          <b-spinner small class="mr-1"></b-spinner>
          Saving...
        </b-button>
      </div>
    </form>
  </div>
</template>

<script>
import moment from '@/node_modules/moment/moment'
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'

export default {
  name: 'FormRunningHours',
  props: {
    fleetDetail: null,
    selectedData: null,
    isFormDetail: Boolean,
  },
  data() {
    return {
      fleetOptions: [],
      dataForm: [],
      loading: false,
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...pmsActions,
    handleSelect(val, idx) {
      const selected = this.fleetOptions.find((el) => el.id == val)
      if (!selected || !this.dataForm[idx]) return
      this.dataForm[idx].runningHours =
        selected.powers?.map((el) => ({
          vehiclePowerId: el?.id,
          engineName: el?.powerType?.name,
          minutes: '',
          powerSeriesId: el.powerSeries.id,
          powertypeId: el.powerType.id,
        })) || []
    },
    timeToMinutes(timeStr) {
      const duration = moment.duration(timeStr, 'HH:mm')
      return duration.asMinutes()
    },
    async fetchFleets() {
      let params = {
        page: 1,
        perPage: 9999,
        showAll: true,
        active: true,
      }

      let res = await this.getFleets(params)

      if (res.status) {
        if (res.data && res.data.length > 0) {
          this.fleetOptions = res.data.map((val) => ({
            ...val,
            text: val.name,
            value: val.id,
          }))
          this.fleetFilteredOptions = this.fleetOptions
        }
      }
    },
    handleCheckAll(e) {
      const { checked } = e.target
      this.dataForm.forEach((item) => {
        item.checked = checked
      })
    },
    addForm() {
      this.dataForm.push({
        vehicle_id: this.fleetDetail?.id,
        date: '',
        checked: false,
        runningHours: [
          {
            vehiclePowerId: '',
            engineName: '',
            minutes: '',
          },
        ],
      })
    },
    deleteForm(idx) {
      this.dataForm = this.dataForm.filter((_, i) => i !== idx)
    },
    bulkDeleteForm() {
      this.dataForm = this.dataForm.filter((el, i) => !el.checked)
    },
    toHourMinute(totalMinutes) {
      const duration = moment.duration(totalMinutes, 'minutes')
      const hours = Math.floor(duration.asHours())
      const minutes = duration.minutes()
      return [hours, minutes]
    },
    toMinutes(hour, minutes) {
      return Number(hour) * 60 + Number(minutes)
    },
    minutesToDecimalHours(minutes) {
      if (!minutes || isNaN(minutes)) return 0
      const hours = minutes / 60
      return parseFloat(hours.toFixed(2)) // 2 angka desimal
    },
    handleBlurInput(e, subItem, type) {
      let value = e.target.value
      if (type === 'hours') {
        if (value > 24) subItem.hours = 24
        if (value < 0) subItem.hours = 0
      } else if (type === 'minutes') {
        if (value > 59) subItem.minutes = 59
        if (value < 0) subItem.minutes = 0
      }
    },
    async handleSubmit() {
      this.loading = true
      const forms = this.dataForm
        ?.filter((el) => el?.date && el?.vehicle_id)
        .map((item) => ({
          log_date: moment(item?.date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          remark: 'daily running hours',
          vehicle_id: item.vehicle_id,
          running_histories: item?.runningHours.map((el) => ({
            vehicle_power_id: el?.vehiclePowerId,
            power_type_id: el.powertypeId,
            power_series_id: el.powerSeriesId,
            running_minutes: this.toMinutes(el?.hours, el?.minutes),
            running_hours_day: this.minutesToDecimalHours(
              this.toMinutes(el?.hours, el?.minutes)
            ),
            ermark: '',
          })),
        }))
      const res = await this.createRunningHoursV3(forms)
      if (res.status == 'success') {
        this.$swal(
          'Success',
          res?.data?.message ??
            `Success ${this.selectedData ? 'Update' : 'Save'} Running Hours`,
          'success'
        ).then((result) => {
          if (result.isConfirmed) {
            this.$emit('close')
          }
        })
        this.$emit('refetch')
      } else {
        this.$swal(
          'Error',
          res?.data?.message || 'Failed Save Running Hours',
          'error'
        )
      }
      this.loading = false
    },
    handleSetDefault() {
      if (this.selectedData) {
        console.log(this.selectedData)
        this.dataForm = [
          {
            vehicle_id: this.selectedData?.vehicle_id,
            date: null,
            checked: false,
            runningHours: [
              {
                vehiclePowerId: '',
                engineName: '',
                minutes: '',
              },
            ],
          },
        ]
      } else {
        // this.dataForm = [
        //   {
        //     vehicle_id: this.fleetDetail?.id,
        //     date: '',
        //     checked: false,
        //     runningHours: this.fleetDetail?.powers?.map((el) => ({
        //       vehiclePowerId: el?.id,
        //       engineName: el?.powerType?.name,
        //       hours: null,
        //       minutes: null,
        //     })),
        //   },
        // ]
      }
    },
  },
  mounted() {
    this.handleSetDefault()
    this.fetchFleets()
  },
}
</script>
<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
</style>
